import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { closeModal } from '@/store/common/actions';
import React, { useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Loader';
import './styles.scss';

interface Props {
    success: boolean;
    loading: boolean;
    description: React.ReactElement<any, string | React.JSXElementConstructor<any>> | null | undefined;
}

const ResultModal: React.FC<Props> = ({ success, description, loading }: Props) => {
    const { isVisible } = useSelector((state: ApplicationState) => ({
        isVisible: state.common.modal[Constants.modal.ACTIVATE_INACTIVATE_RESULT_MODAL].isVisible,
    }));
    const dispatch = useDispatch();

    const dismissModalHandler = () => {
        dispatch(closeModal(Constants.modal.ACTIVATE_INACTIVATE_RESULT_MODAL));
    };
    const timeoutRef = useRef<any>();

    useEffect(() => {
        if (isVisible && !loading) {
            timeoutRef.current = setTimeout(() => {
                dismissModalHandler();
            }, 3000);
        } else {
            clearTimeout(timeoutRef.current);
        }
        return () => clearTimeout(timeoutRef.current);
    }, [isVisible, dismissModalHandler, loading]);

    return (
        <Modal.Body className="body-content">
            <div className="content-container">
                {loading && <Loader />}
                {success && !loading && <i className="material-icons-outlined align-middle success-icon">check_circle_outline</i>}
                {!success && !loading && <i className="material-icons-outlined align-middle close-icon">cancel</i>}

                {!loading && <div className="modal-description">{description}</div>}
            </div>
        </Modal.Body>
    );
};

export default ResultModal;
